import { useId, useState } from 'react';
import { useVizChartTheme } from '../../hooks/useVizChartTheme';
import { useVizFormatters } from '../../hooks/useVizFormatters';
import { LineChartBlock } from '../../viz.types';
import { GAP_FROM_LINE, getEndLabelWidth } from './LineEndLabel';
import { getLineChartEndValue, getLineChartSummary } from './lineChartBlock.utils';

export const useLineChartBlock = (block: LineChartBlock) => {
  const formatters = useVizFormatters(block.format);
  const chartTheme = useVizChartTheme();

  const ranges = (block.ranges ?? []).filter((range) => range.points <= block.series.length);
  const [rangeIndex, setRangeIndex] = useState(0);
  const selectedIndex = rangeIndex < ranges.length ? rangeIndex : 0;
  const selectedRange = ranges.at(selectedIndex) ?? null;
  const series = selectedRange ? block.series.slice(-selectedRange.points) : block.series;

  const gradientId = `line-chart-gradient-${useId().replace(/:/g, '')}`;
  const gutter = chartTheme.toPx(2);

  const endValue = getLineChartEndValue(series);
  const endLabel = endValue === null ? '' : formatters.formatCompact(endValue);
  const lastIndex = series.length - 1;

  return {
    formatters,
    chartTheme,
    gradientId,
    summary: getLineChartSummary({ series, kind: block.summary }),
    chartMargin: {
      top: chartTheme.toPx(1),
      right: endLabel ? getEndLabelWidth(endLabel) + GAP_FROM_LINE + gutter : gutter,
      left: 0,
      bottom: chartTheme.toPx(0.5),
    },
    ranges,
    selectedIndex,
    selectRange: setRangeIndex,
    data: series.map((point, index) => ({
      label: point.x,
      value: point.y,
      endLabel: index === lastIndex ? endLabel : undefined,
    })),
  };
};
